import React from "react";
import { useNavigate } from "react-router-dom";

const ProfilePage = () => {
    const navigate = useNavigate();

    // get local storage user name and email
    const user = JSON.parse(localStorage.getItem('user'));
    if (!user) {
        navigate('/login');
    }
    
    return (
        <div style={styles.profile}>
            <h2>{user?.name}</h2>
            <p style={styles.email}>{user?.email}</p>
            <h2>Your Prints</h2>
            { user?.prints === undefined || user?.prints.length === 0 ? (
                <p>No prints submitted</p>
            ) : (
                <div>
                    {user?.prints.map((print, index) => (
                        <div key={index}>
                            <p>{print.date}</p>
                            <p>{print.name}</p>
                            <p>{print.price}</p>
                            <p>{print.status}</p>
                        </div>
                    ))}
                </div>
            )}
        </div>
    )
}

const styles = {
    profile: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    email: {
        paddingBottom: 100,
    }
};

export default ProfilePage;